export function moveItem(inputArray: any, from: number, to: number) {
  let numberOfDeletedElm = 1;
  const elm = inputArray.splice(from, numberOfDeletedElm)[0];
  numberOfDeletedElm = 0;
  inputArray.splice(to, numberOfDeletedElm, elm);
}